export default "__VITE_ASSET__DrlFzFSV__"